export const dataURLtoFile = (dataurl, filename) => {
    console.log(filename);
    
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
}

export const onUpdateFilterData = (IDcard, userData) => {
    const newUpdatedObj = { ...IDcard };

    // ID CARD FRONT PARSING
    let front_image_objects = [];
    let front_text_objects = [];

    newUpdatedObj?.view_data?.id_front?.image_objects?.forEach(img => {
        front_image_objects?.push({ ...img, src: userData?.user_details[img.tag] })
    })

    newUpdatedObj?.view_data?.id_front?.text_objects?.forEach(text => {
        front_text_objects?.push({ ...text, text: userData?.user_details[text.tag] })
    })

    Object.assign(newUpdatedObj?.view_data?.id_front?.image_objects, front_image_objects);
    Object.assign(newUpdatedObj?.view_data?.id_front?.text_objects, front_text_objects);

    // ID CARD BACK PARSING
    if (newUpdatedObj?.type == 2) {
        let back_image_objects = [];
        let back_text_objects = [];

        newUpdatedObj?.view_data?.id_back?.image_objects?.forEach(img => {
            back_image_objects?.push({ ...img, src: userData?.user_details[img.tag] })
        })

        newUpdatedObj?.view_data?.id_back?.text_objects?.forEach(text => {
            back_text_objects?.push({ ...text, text: userData?.user_details[text.tag] })
        })

        Object.assign(newUpdatedObj?.view_data?.id_back?.image_objects, back_image_objects);
        Object.assign(newUpdatedObj?.view_data?.id_back?.text_objects, back_text_objects);
    }

    return newUpdatedObj;    
}